"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AdAccountStatus = void 0;

var _immutable = require("immutable");

var Warnings = {
  accountNotAccessible: {
    use: 'danger',
    message: 'inaccessible'
  },
  accountInactive: {
    use: 'danger',
    message: 'inactive'
  }
};
var AdAccountStatus = {
  ACTIVE: 'ACTIVE',
  ON_HOLD: 'ON_HOLD',
  CLOSED: 'CLOSED',
  UNKNOWN: 'UNKNOWN'
};
exports.AdAccountStatus = AdAccountStatus;

var _getWarningLevel = function getWarningLevel(user) {
  if (user.network === 'FACEBOOK' || user.network === 'LINKEDIN') {
    if (!user.accessible) {
      return Warnings.accountNotAccessible;
    }
  }

  if (user.status !== AdAccountStatus.ACTIVE) {
    return Warnings.accountInactive;
  }

  return null;
};

var formatAdWordsAccountId = function formatAdWordsAccountId(accountId) {
  // Format like AdWords as "123-456-7890"
  var idString = accountId.toString();
  return idString.substring(0, 3) + "-" + idString.substring(3, 6) + "-" + idString.substring(6);
};

var _getFormattedName = function getFormattedName(accountName, accountId, network) {
  if (network === 'ADWORDS') {
    accountId = formatAdWordsAccountId(accountId);
  }

  return accountName ? accountName + " (" + accountId + ")" : "" + accountId;
};

var _default = (0, _immutable.Record)({
  network: null,
  accountId: null,
  accountName: null,
  connectedUser: null,
  connectedUserId: null,
  connectedAt: null,
  currencyCode: null,
  accessible: null,
  trackingEnabled: null,
  status: AdAccountStatus.ACTIVE,
  getDisplayName: function getDisplayName() {
    return this.getFormattedName();
  },
  getFormattedName: function getFormattedName() {
    return _getFormattedName(this.accountName, this.accountId, this.network);
  },
  getWarningLevel: function getWarningLevel() {
    return _getWarningLevel(this);
  }
});

exports.default = _default;